/**
 * Check whether the application is running inside an iframe (Evo shell).
 * The cookie SDK requires an Evo parent window to function correctly.
 *
 * Extracted into its own module so that tests can mock this function
 * via module mocking — internal function calls within the same module
 * bypass module mocks.
 */
export function isRunningInEvoIframe(): boolean {
  try {
    return window.self !== window.top;
  } catch {
    // Cross-origin restriction means we ARE in an iframe
    return true;
  }
}
